export interface GetSimpleAcceptCollectionsRequest {
  ids: number[]
}

export function GetSimpleAcceptCollectionsRequestToJSON(
  value: GetSimpleAcceptCollectionsRequest
): any {
  return {
    ids: value.ids.length > 0 ? value.ids : undefined
  }
}
